<app-basic-card [css]="'mb-3'">
    <h5>Cruscotto operazioni</h5>
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
    <div class="d-flex justify-content-start">
        <button mat-flat-button color="primary" (click)="onSearchButtonClick()">{{'ricerca' | uppercase}}</button>
        <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
    </div>
</app-basic-card>

<ng-container *ngIf="dataSource && dataSource.length > 0; else noOperationsBlock">
    <app-basic-card class="w-100">
        <app-be-paginated-table class="w-100" [dataSource]="dataSource" [tableKeys]="tableKeys"
            (changeRequested)="onTableChange($event)" (actionSelected)="onDetailRequested($event)">
        </app-be-paginated-table>
    </app-basic-card>
</ng-container>
<ng-template #noOperationsBlock>
    <ng-container *ngIf="!notYetSearched">
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <mat-icon class="no-results-icon" aria-hidden="false" aria-label="no-documents-icon"
                fontIcon="file_copy_off"></mat-icon>
            <h4 class="no-docs-text">Nessun risultato trovato</h4>
        </div>
    </ng-container>
</ng-template>